export default __webpack_public_path__ + "static/Rocket-7f04581ba4e2d4911d62111b0042a044.svg";